import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get, debounce } from 'lodash';

export class IFrame extends PureComponent {

  static propTypes = {
    src: PropTypes.string,
    onLoad: PropTypes.func,
    contentWidth: PropTypes.bool,
    minHeight: PropTypes.number
  };

  /** @type {HTMLIFrameElement} */
  iFrame;

  componentDidMount() {
    window.addEventListener('resize', this._toContentHeight);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._toContentHeight);
  }


  render() {
    return (
      <iframe
        ref={this._setRef}
        className={`esk-iframe ${this.props.contentWidth ? 'content-width' : ''}`}
        width='100%'
        src={this.props.src}
        scrolling="no"
        onLoad={this._handleLoad}
      />
    );
  }

  _toContentHeight = debounce(() => {
    const document = get(this.iFrame, 'contentWindow.document');
    if (!document) {
      return;
    }
    this.resetHeight();
    const { minHeight, contentWidth } = this.props;
    const height = minHeight || 0;
    const contentHeight = document.body.scrollHeight < height ? height : document.body.scrollHeight;
    this.iFrame.height = `${contentHeight}px`;
    if (contentWidth) {
      this.iFrame.width = `${document.body.scrollWidth}px`;
    }
  }, 250, { leading: true, trailing: true })

  resetHeight = () => {
    this.iFrame.height = 0;
  }

  _handleLoad = (event) => {
    this._setRef(event.target);
    this._toContentHeight();

    if (this.props.onLoad) {
      this.props.onLoad();
    }
  }

  _setRef = (iframe) => { this.iFrame = iframe; }

}
